<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row class="mx-2 my-1">
        <v-col cols="8">
          <v-card>
            <v-card-title>
              {{ $t("Top.orderCount.title") }}
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content class="justify-center">
                  <div id="year" style="height: 30vh"></div>
                </v-list-item-content>
                <v-list-item-content class="justi fy-center">
                  <div id="today" style="height: 30vh"></div>
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <div id="week" style="height: 30vh;"></div>
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <div id="month" style="height: 30vh;"></div>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" v-if="showBalance">
          <v-card>
            <v-card-title>
              {{ $t("Top.balance") }}
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{ $t('Global.money') }}{{ balance | formatMoney }}</v-card-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mx-2 my-1" v-if="userType != 0">
        <v-col cols="12">
          <v-card>
            <v-tabs
              v-model="tab"
              height="64"
              class="ms-3"
              background-color="transparent"
            >
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.stockMin_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.stockMax_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.nearday_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.expired_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.stock_take_plan") }}
                </v-card-title>
              </v-tab>
            </v-tabs>
            <v-card-text>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-data-table
                    :headers="stockMinsHeaders"
                    :items="stockMins"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.material_code="{ item }">
                      <span>
                        {{
                          $t("Top.materialsFields.code", [item.material_code])
                        }}
                      </span>
                    </template>
                    <template v-slot:item.notice_num="{ item }">
                      <span class="red--text">
                        {{ -item.notice_num }}
                      </span>
                    </template>

                    <template v-slot:item.stock_min="{ item }">
                      <span>
                        {{ item.stock_min | formatTwoDot }}
                      </span>
                    </template>
                    <template v-slot:item.current_count="{ item }">
                      <span>
                        {{ item.current_count | formatTwoDot }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="stockMaxsHeaders"
                    :items="stockMaxs"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.material_code="{ item }">
                      <span>
                        {{
                          $t("Top.materialsFields.code", [item.material_code])
                        }}
                      </span>
                    </template>
                    <template v-slot:item.notice_num="{ item }">
                      <span class="red--text">
                        {{ item.notice_num }}
                      </span>
                    </template>
                    <template v-slot:item.stock_max="{ item }">
                      <span>
                        {{ item.stock_max | formatTwoDot }}
                      </span>
                    </template>
                    <template v-slot:item.current_count="{ item }">
                      <span>
                        {{ item.current_count | formatTwoDot }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="neardayMaterialsHeaders"
                    :items="neardayMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.expired_date="{ item }">
                      <span class="red--text">
                        {{ item.expired_date | diffDate }}
                      </span>
                    </template>
                    <template v-slot:item.material_code="{ item }">
                      <span>
                        {{
                          $t("Top.materialsFields.code", [item.material_code])
                        }}
                      </span>
                    </template>
                    <template v-slot:item.material_count="{ item }">
                      <span>
                        {{ item.material_count | formatTwoDot }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="expiredMaterialsHeaders"
                    :items="expiredMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.material_code="{ item }">
                      <span>
                        {{
                          $t("Top.materialsFields.code", [item.material_code])
                        }}
                      </span>
                    </template>
                    <template v-slot:item.expired_date="{ item }">
                      <span class="red--text">
                        {{ item.expired_date | diffDate }}
                      </span>
                    </template>
                    <template v-slot:item.material_count="{ item }">
                      <span>
                        {{ item.material_count | formatTwoDot }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="noticeStockTakePlanHeaders"
                    :items="noticeStockTakePlan"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.created="{ item }">
                      <span>
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.term_date="{ item }">
                      <span>
                        {{ item.term_date | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Top from "@/api/top";
import * as echarts from "echarts";
import {mapState} from "vuex";

var intervalRef = void 0;
var notifyDisplayed = 0;
const todayData = [
  {
    value: 0,
    name: i18n.t("Top.orderCount.today"),
    itemStyle: {
      color: '#1FA396'
    },
    title: {
      color: '#000000',
      offsetCenter: ['0%', '-30%']
    },
    detail: {
      color: '#000000',
      valueAnimation: true,
      formatter: i18n.t("Top.orderCount.formatter"),
      offsetCenter: ['0%', '0%']
    }
  }
];

const weekData = [
  {
    value: 0,
    name: i18n.t("Top.orderCount.week"),
    itemStyle: {
      color: '#1FA396'
    },
    title: {
      color: '#000000',
      offsetCenter: ['0%', '-30%']
    },
    detail: {
      color: '#000000',
      valueAnimation: true,
      formatter: i18n.t("Top.orderCount.formatter"),
      offsetCenter: ['0%', '0%']
    }
  }
];

const monthData = [
  {
    value: 0,
    name: i18n.t("Top.orderCount.month"),
    itemStyle: {
      color: '#1FA396'
    },
    title: {
      color: '#000000',
      offsetCenter: ['0%', '-30%']
    },
    detail: {
      color: '#000000',
      valueAnimation: true,
      formatter: i18n.t("Top.orderCount.formatter"),
      offsetCenter: ['0%', '0%']
    }
  }
];

const yearData = [
  {
    value: 0,
    name: i18n.t("Top.orderCount.year"),
    itemStyle: {
      color: '#1FA396'
    },
    title: {
      color: '#000000',
      offsetCenter: ['0%', '-30%']
    },
    detail: {
      color: '#000000',
      valueAnimation: true,
      formatter: i18n.t("Top.orderCount.formatter"),
      offsetCenter: ['0%', '0%']
    }
  }
];

export default {
  components: { Breadcrumbs },
  data: () => ({
    tab: null,
    neardayMaterials: [],
    expiredMaterials: [],
    stockMins: [],
    stockMaxs: [],
    balance: 0,
    showBalance: false,
    noticeStockTakePlan: [],
  }),
  mounted() {
    if (this.userType != 0) {
      this.refreshMaterials();
      this.stockMaterials();
    }
    if (this.userType != 2) {
      this.refresh()
      intervalRef = setInterval(() => {
        if (!notifyDisplayed) {
          this.refresh();
        }
      }, 5000);
    }
    if (this.userType == 1) {
      this.stockTakePlan();
    }
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: true,
        href: "/home",
      },
    ],
    neardayMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_category"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.unit"),
        align: "start",
        value: "unit",
      },
      {
        text: i18n.t("Top.materialsFields.nearday_count"),
        align: "center",
        value: "material_count",
      },
      {
        text: i18n.t("Top.materialsFields.nearday"),
        align: "center",
        value: "expired_date",
      },
    ],
    expiredMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_category"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.unit"),
        align: "start",
        value: "unit",
      },
      {
        text: i18n.t("Top.materialsFields.expired_count"),
        align: "center",
        value: "material_count",
      },
      {
        text: i18n.t("Top.materialsFields.expired"),
        align: "center",
        value: "expired_date",
      },
    ],
    stockMinsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_category"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.unit"),
        align: "start",
        value: "unit",
      },
      {
        text: i18n.t("Top.materialsFields.current_count"),
        align: "center",
        value: "current_count",
      },
      {
        text: i18n.t("Top.materialsFields.stock_min"),
        align: "center",
        value: "stock_min",
      },
      {
        text: i18n.t("Top.materialsFields.notice_num_min"),
        align: "center",
        value: "notice_num",
      },
    ],
    stockMaxsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_category"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.unit"),
        align: "start",
        value: "unit",
      },
      {
        text: i18n.t("Top.materialsFields.current_count"),
        align: "center",
        value: "current_count",
      },
      {
        text: i18n.t("Top.materialsFields.stock_max"),
        align: "center",
        value: "stock_max",
      },
      {
        text: i18n.t("Top.materialsFields.notice_num_max"),
        align: "center",
        value: "notice_num",
      },
    ],
    noticeStockTakePlanHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.stock_take_code"),
        align: "start",
        value: "stock_take_code",
      },
      {
        text: i18n.t("Top.materialsFields.created"),
        align: "start",
        value: "created",
      },
      {
        text: i18n.t("Top.materialsFields.term_date"),
        align: "start",
        value: "term_date",
      },
      {
        text: i18n.t("Top.materialsFields.remain_days"),
        align: "start",
        value: "remain_days",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["userType"]),
  },
  methods: {
    refreshMaterials() {
      Top.materials({ type: 3 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.neardayMaterials = response.data.materials;
            Top.materials({ type: 1 }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.expiredMaterials = response.data.materials;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    stockMaterials() {
      Top.stockMaterials({ type: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockMaxs = response.data.materials;
            Top.stockMaterials({ type: 2 }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.stockMins = response.data.materials;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    drawLineChart(elementId, data) {
      this.chartLine = echarts.init(document.getElementById(elementId));
      // 指定图表的配置项和数据
      var option = {
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 0,
                borderColor: '#464646'
              }
            },
            axisLine: {
              lineStyle: {
                width: 10
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 50
            },
            data: data,
            title: {
              fontSize: 14
            },
            detail: {
              width: 50,
              height: 14,
              fontSize: 28,
              color: 'inherit',
              borderColor: 'none',
              borderRadius: 20,
              borderWidth: 1
            }
          }
        ]
      };

      this.chartLine.setOption({
        series: [
          {
            data: data,
            pointer: {
              show: false
            }
          }
        ]
      });

      this.chartLine.setOption(option);

      // 使用刚指定的配置项和数据显示图表。
      // this.chartLine.setOption(option);
    },
    refresh() {
      Top.getOrderCount().then(
        function (response) {
          if (response.data.status.isOK()) {
            let today_count = response.data.today_count
            let week_count = response.data.week_count
            let month_count = response.data.month_count
            let quarter_count = response.data.quarter_count
            let year_count = response.data.year_count
            let last_year_count = response.data.last_year_count
            todayData[0].value = today_count ? (today_count / week_count) * 100 : 0;
            todayData[0].detail.formatter = today_count + "单";
            weekData[0].value = week_count ? (week_count / month_count) * 100 : 0;
            weekData[0].detail.formatter = week_count + "单";
            monthData[0].value = month_count ? (month_count / quarter_count) * 100 : 0;
            monthData[0].detail.formatter = month_count + "单";
            yearData[0].value = year_count ? (year_count / last_year_count) * 100 : 0;
            yearData[0].detail.formatter = year_count + "单";
            this.drawLineChart('today', todayData)
            this.drawLineChart('week', weekData)
            this.drawLineChart('month', monthData)
            this.drawLineChart('year', yearData)
          }
        }.bind(this)
      );
      Top.getShopInfo().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.balance = response.data.balance
            this.showBalance = response.data.showBalance
          }
        }.bind(this)
      )
    },
    stockTakePlan() {
      Top.stockTakePlan().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.noticeStockTakePlan = response.data.stock_take_plan_notice;
          }
        }.bind(this)
      );
    },
  },

  beforeDestroy() {
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>